import type { DomainMapper } from '../types';

import dk from './dk';
import fi from './fi';
import gb from './gb';
import no from './no';
import se from './se';
import us from './us';
import de from './de';

const localDomains: DomainMapper[] = [gb, de, us, se, no, fi, dk];

export default localDomains;
